import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";
// import { Plugin } from "vue-fragment";
import VueMask from "v-mask";
import { VueMaskDirective } from "v-mask";
import { VueMaskFilter } from "v-mask";
import frag from "vue-frag";
import VueYoutube from "vue-youtube";
// import VueFakeInput from 'vue-fake-input';

// Vue.use(VueFakeInput);

Vue.use(Vuetify);
Vue.use(VueYoutube);
// Vue.use(Plugin);
Vue.directive("frag", frag);
Vue.use(VueMask);
Vue.directive("mask", VueMaskDirective);
Vue.filter("VMask", VueMaskFilter);
export default new Vuetify({
  icons: {
    iconfont: "mdiSvg" // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        background: "#2D3436",
        cardOne: "#ffffff",
        primary: "#2D3436",
        secondary: colors.grey.lighten5,

        primaryApp: colors.white,
        secondaryApp: colors.grey.lighten3,
        btnSuccess: "#C9412B", // CTA: coral oscurecido (blanco sobre #E8563F no llega a AA)
        btnCancel: "#A3A3A3",
        info: colors.blue.lighten2,
        Colorsuccess: colors.green
      }
    }
  }
});
